import React, { useState, useEffect } from "react";
import { X, Edit3, Loader2 } from "lucide-react";
import { showToast } from "../../components/common/notification/Notification";
import { editNetworkPartner } from "./networkApi";

const EditPartnerModal = ({ show, partner, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    id: "",
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_address: "",
    country_name: "India",
    state_name: "",
    city_name: "",
    area_name: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (partner) {
      setFormData({
        id: partner.id,
        first_name: partner.first_name || partner.firstName || "",
        last_name: partner.last_name || partner.lastName || "",
        mobile_number: (partner.mobile_number || partner.mobileNo || "").replace(/^91/, ""),
        email_address: partner.email_address || partner.emailId || "",
        country_name: partner.country_name || partner.country || "India",
        state_name: partner.state_name || partner.state || "",
        city_name: partner.city_name || partner.city || "",
        area_name: partner.area_name || partner.area || "",
      });
    }
  }, [partner]);

  if (!show || !partner) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name?.trim()) {
      showToast("First Name is required", { type: "error" });
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await editNetworkPartner(formData);

      if (res?.statusType === "SUCCESS" || res?.status === "SUCCESS" || res?.network) {
        showToast("Partner details updated successfully", { type: "success" });
        onSuccess?.();
        onClose?.();
      } else {
        showToast(res?.text || res?.message || "Failed to update partner", { type: "error" });
      }
    } catch (err) {
      console.error("Edit partner error:", err);
      showToast(err?.response?.data?.text || "An error occurred while updating partner", {
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="net-modal-overlay" onClick={onClose}>
      <div className="net-modal" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit} className="net-modal-form">
          <div className="net-modal__header">
            <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  background: "#eff6ff",
                  color: "#2563eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Edit3 size={18} />
              </div>
              <div>
                <h3 className="net-modal__title">Edit Network Partner</h3>
                <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
                  Update partner profile and contact details
                </p>
              </div>
            </div>
            <button type="button" className="net-drawer__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          <div className="net-modal__body">
            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">First Name *</label>
                <input
                  type="text"
                  name="first_name"
                  className="net-form-input"
                  value={formData.first_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="net-form-input"
                  value={formData.last_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">Mobile Number *</label>
                <input
                  type="tel"
                  name="mobile_number"
                  className="net-form-input"
                  value={formData.mobile_number}
                  onChange={handleInputChange}
                  maxLength={10}
                  required
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">Email Address</label>
                <input
                  type="email"
                  name="email_address"
                  className="net-form-input"
                  value={formData.email_address}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-grid-2">
              <div className="net-form-group">
                <label className="net-form-label">State</label>
                <input
                  type="text"
                  name="state_name"
                  className="net-form-input"
                  value={formData.state_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="net-form-group">
                <label className="net-form-label">City</label>
                <input
                  type="text"
                  name="city_name"
                  className="net-form-input"
                  value={formData.city_name}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="net-form-group">
              <label className="net-form-label">Area / Locality</label>
              <input
                type="text"
                name="area_name"
                className="net-form-input"
                value={formData.area_name}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="net-modal__footer">
            <button type="button" className="net-btn net-btn--secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="net-btn net-btn--primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={16} className="net-spin" /> Saving...
                </>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditPartnerModal;
